<template>
  <ResourceDialog
    @save="openDownload"
    ref="dialog"
    :processing="processing"
    :save-button-disabled="disabled"
    save-button-text="Download"
    title="Download search results"
  >
    <template #form>
      <v-row dense="">
        <v-col
          v-if="lists && lists.length == 0"
          cols="12"
        >
          <div class="fs-16 c-black">
            {{ $bct('Save providers to your favorite lists so you can download them.') }}
          </div>
        </v-col>
        <v-col
          v-for="(list, index) in lists"
          :key="index"
          cols="12"
        >
          <v-checkbox
            v-model="list.selected"
            :label="list.name"
            class="mt-0"
            data-cy="favorites-list-check"
            false-icon="check_box_outline_blank"
            hide-details=""
            true-icon="check_box"
          />
        </v-col>
      </v-row>
      <div v-if="lists && lists.length > 0">
        <v-row class="mb-2 mt-4">
          <v-col class="py-0 c-black fs-16">
            {{ $bct('Download format') }}
          </v-col>
        </v-row>
        <v-row
          class="mb-3"
          dense
        >
          <v-col>
            <v-btn-toggle
              v-model="format"
              color="primary"
            >
              <v-btn
                :ripple="false"
                value="csv"
              >
                {{ $bct('CSV') }}
              </v-btn>
              <v-btn
                :ripple="false"
                value="pdf"
              >
                {{ $bct('PDF') }}
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
        <v-row
          class="mb-2 mt-4"
          dense
        >
          <v-col>
            <div class="py-0 c-black fs-16 mb-2">
              {{ $bct('Language') }}
            </div>
            <div class="bc-body-md">
              <v-select
                v-model="locale"
                :aria-label="$bct('Language options')"
                :items="languages"
                variant="filled"
                hide-details
              />
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
  </ResourceDialog>
</template>

<script setup>
import useApi from '@/shared/composables/useApi';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import ResourceDialog from '@/shared/components/form/ResourceDialog.vue';

const props = defineProps({
  lists: {
    type: Array,
    default: null,
  },
});

const { api } = useApi();
const store = useStore();
const route = useRoute();
const { locale: i18nLocale } = useI18n();
const $bct = inject('translator');

const dialog = ref(null);
const format = ref(null);
const locale = ref(i18nLocale.value);
const processing = ref(false);
const languages = computed(() => store.state.languages);

const selected = computed(() => {
  return props.lists.filter((list) => list.selected).map((list) => list.id);
});

const disabled = computed(() => {
  return !format.value || selected.value.length < 1;
});

watch(i18nLocale, (newVal) => {
  locale.value = newVal;
});

const open = () => {
  processing.value = false;
  dialog.value.open();
};

const openDownload = () => {
  processing.value = true;
  const params = {
    format: format.value,
    group_id: route.query.group_id,
    lists: selected.value.join(','),
    locale: locale.value,
  };
  api.downloadListsUrl(params);
  dialog.value.close();
};

defineExpose({
  open,
});
</script>
